<template>
  <div class="recommendation-wrap">
    <div class="recommendation" v-loading="loading">

      <el-input class="recommendation-from" type="textarea" readonly :value="recommendation" :autosize="{ minRows: 9, maxRows: 9}"></el-input>
      <el-form :model="recommendationForm" :rules="recommendationRules" ref="recommendationForm" label-width="120px" class="demo-ruleForm" label-position="top">

        <el-form-item :label="$t('feed.settings.common.recommendationForm.recommendation')" prop="value">
          <el-input v-model="recommendationForm.value"></el-input>
        </el-form-item>

        <el-button type="primary" @click="submitRecommendation('recommendationForm')">{{$t('feed.settings.common.recommendationForm.submitRecommendation')}}</el-button>
      </el-form>
    </div>
    <div class="description" v-loading="loadingDescription">
      <el-form :model="descriptionForm" :rules="descriptionRules" ref="descriptionForm" label-width="120px" class="demo-ruleForm" label-position="top">

        <el-form-item :label="$t('feed.settings.common.recommendationForm.description')" prop="value">
          <el-input type="textarea" v-model="descriptionForm.value" :autosize="{ minRows: 9, maxRows: 9}"></el-input>
        </el-form-item>

        <el-button class="descr-button" type="primary" style="margin-top: 90px" @click="submitDescription('descriptionForm')">
          {{$t('feed.settings.common.recommendationForm.saveDescription')}}
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
  // api
  import { addRecommendationApi, threadsSaveApi } from "../../../../../../api/feeds";

  // components
  import notify from "../../../../../../helpers/notify";

  export default {
    name: 'Recommendation',
    data() {
      return {
        loading: false,
        loadingDescription: false,
        recommendation: '',
        recommendationForm: {
          value: ''
        },
        descriptionForm: {
          value: ''
        },
        recommendationRules: {
          value: [
            { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
          ],
        },
        descriptionRules: {
          value: [
            { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
          ],
        },
      };
    },
    computed: {
      feed() {
        return this.$store.getters['feed'](this.$route.params.threadId)
          ?
            this.$store.getters['feed'](this.$route.params.threadId)
          :
            [];
      },
    },
    methods: {
      submitDescription(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loadingDescription = true;
            this.addDescription(this.descriptionForm.value);
          } else {
            notify.call(this, "Неверно заполнена форма", "error");
            return false;
          }
        });
      },
      submitRecommendation(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addRecommendation(this.recommendationForm.value);
            this.$refs[formName].resetFields();
          } else {
            notify.call(this, "Неверно заполнена форма", "error");
            return false;
          }
        });
      },
      addDescription(description) {
        let params = {
          id: this.$route.params.threadId,
          description,
        };

        threadsSaveApi(params).then(() => {
          this.loadingDescription = false;
          notify.call(this, "Запрос изменен", "success");
        });
      },
      addRecommendation(recommendation) {
        this.loading = true;

        let params = {
          thread_id: this.$route.params.threadId,
        };

        if (recommendation) {
          params = {...params, message: recommendation};
        }

        addRecommendationApi(params).then(resp => {
          resp.data.forEach(item => {
            this.recommendation += item.username + ' ';
            this.recommendation += item.createddate + ': ';
            this.recommendation += item.message + '\r\n';
          });

          this.loading = false;
        });
      },
      getDescription() {
        this.descriptionForm.value = this.feed.description;
      },
    },
    mounted() {
      this.getDescription();
      this.addRecommendation();
    }
  }
</script>

<style>
  .recommendation-wrap {
    display: flex;
    align-items: flex-start;
  }
  .recommendation, .description {
    width: 50%;
    height: 100%;
  }
  .recommendation {
    margin-right: 15px;
  }
  .recommendation-from {
    margin-top: 49px;
  }
   @media screen and (max-width: 480px) {
    .el-button {
      font-size: 10px;
    }
    .el-form-item__label{
      font-size: 10px;
      line-height: unset;
    }
    .recommendation, .description {
      width: 100%;
      height: 100%;
    }
    .recommendation-wrap {
      display: block;
    }
   }
</style>
